import React from 'react';
import {TemplateItem, InlineTemplateItem, TextTemplateItem, ButtonTemplateItem} from '../types/templateStructure';
import InlineTemplateRow from '../components/inlineTemplateRow/InlineTemplateRow';
import ParagraphRow from '../components/paragraphRow/ParagraphRow';
import ParagraphSpacer from '../components/paragraphSpacer/ParagraphSpacer';
import WhatsAppButtonRow from '../components/whatsAppButtonRow/WhatsAppButtonRow';
import {convertToHtml} from './formatUtils';

interface RenderTemplateItemProps {
    item: TemplateItem;
    index: number;
    handleItemChange: (index: number, updatedItem: TemplateItem) => void;
    setLastFocusedEditable: (element: HTMLElement | null) => void;
    updateSavedCursorOffset: () => void;
    variables: Record<string, any>;
    t: (key: string) => string;
}

export function renderTemplateItem({
    item,
    index,
    handleItemChange,
    setLastFocusedEditable,
    updateSavedCursorOffset,
    variables,
    t,
}: RenderTemplateItemProps): React.ReactNode {
    const whatsappItems = {
        inline: () => (
            <InlineTemplateRow
                key={`inline-${index}`}
                item={item as InlineTemplateItem}
                structureIndex={index}
                onChange={(updatedItem) => handleItemChange(index, updatedItem)}
                onEditableFocus={setLastFocusedEditable}
                onEditableCursorMove={updateSavedCursorOffset}
            />
        ),
        text: () => {
            const textItem = item as TextTemplateItem;
            const formattedHtml = convertToHtml(textItem?.value, variables, t);
            return (
                <ParagraphRow
                    key={`text-${index}`}
                    structureIndex={index}
                    content={formattedHtml}
                    onChange={(newContent) => handleItemChange(index, {...item as TextTemplateItem, value: newContent})}
                    setLastFocusedEditable={setLastFocusedEditable}
                    updateSavedCursorOffset={updateSavedCursorOffset}
                />
            );
        },
        empty: () => <ParagraphSpacer key={`empty-${index}`} />,
        button: () => {
            const buttonItem = item as ButtonTemplateItem;
            return (
                <WhatsAppButtonRow
                    key={`button-${index}`}
                    buttons={[{value: buttonItem?.value}]}
                />
            );
        }
    };
    
    return whatsappItems[item.type]?.() || null;
}
